import React from "react";
import styled from "styled-components";
// import { FaInstagram, FaFacebook } from 'react-icons/fa';
import { Logo } from "../header/header";
import { Instagram, Facebook } from "@material-ui/icons";
import { FacebookIcon, InstagramIcon } from "../styled-components/icons";
import { frontEnd } from "../../config/links";

const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <FooterMainContainer>
        <FooterContent>
          <LogoContainer>
            <LogoWrapper>
              <Logo
                src="/assets/home/logo.png"
                alt="GetThru"
                width={34}
                height={34}
              />
              <LogoText>GetThru</LogoText>
            </LogoWrapper>
          </LogoContainer>
          <StyledNavLink href={frontEnd.gsse}>GSSE</StyledNavLink>
          <StyledNavLink href={frontEnd.gpepau}>RACGP</StyledNavLink>
          <StyledNavLink href={frontEnd.bps}>BPS</StyledNavLink>
          <StyledNavLink href={frontEnd.gpepnz}>GPEP NZ</StyledNavLink>
          <BlogsLink href={frontEnd.blog}>Blogs</BlogsLink>
          <SocialLinks>
            {/* <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon />
            </a> */}
            <a
              href="https://www.facebook.com/profile.php?id=61551502415795&locale=en_GB#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GetThru on Facebook"
            >
              {/* <Facebook style={{ fontSize: 32 }} /> */}
              <FacebookIcon />
            </a>
          </SocialLinks>
        </FooterContent>
        <Copyright>
          © Medical Education Technologies Group Ltd 2016, 82 Alexandria Road,
          Hataitai, Wellington 6021, New Zealand, +64777729830
        </Copyright>
      </FooterMainContainer>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.footer`
  background-color: #1d1b3f;
  padding: 20px 0 0;
  color: white;
  width: 100%;
  @media (max-width: 768px) {
    height: auto;
  }
`;

const FooterMainContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterContent = styled.div`
  width: 100%;
  padding: 36px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    align-items: self-start;
    padding: 20px 16px;
    margin-bottom: 0;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  height: 100%;

  a {
    color: white;
    font-size: 24px;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    gap: 24px;
  }
`;

const Copyright = styled.p`
  font-size: 16px;
  margin: 0;
  color: #8d899e;
  border-top: 1px solid #2c2a57;
  padding: 16px 0;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LogoText = styled.span`
  font-size: 18px;
  font-weight: 800;
`;

const StyledNavLink = styled.a`
  font-weight: 700;
  font-size: 16px;
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 0.2s;
  flex: 0 0 auto;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const BlogsLink = styled.a`
  font-size: 16px;
  font-weight: 700;
  color: white;
  text-decoration: none;
  transition: opacity 0.2s;
  text-transform: uppercase;
  flex: 0 0 auto;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export default Footer;
